import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=3708d6bc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=3708d6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708d6bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3708d6bc')) {
      api.createRecord('3708d6bc', component.options)
    } else {
      api.reload('3708d6bc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=3708d6bc&scoped=true&", function () {
      api.rerender('3708d6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22IB2mcVOfTtg/JS/comp/Voucher.vue"
export default component.exports